import React, { Component } from 'react';
import { Table, Button, Alert, Card, Input } from 'reactstrap';
import { Modal, ModalBody,  ModalHeader, ModalFooter} from 'reactstrap';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Row, Col } from 'reactstrap';
import plantilla from './Content/PlantillaDatos.xlsx';
import { AppContext } from '../AppContext';

import url from "./variables/url.js";

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;
const homepage = process.env.REACT_APP_EXP;

export class FileUpload extends Component {
  static displayName = FileUpload.name;

    constructor(props) {
        super(props)
        this.state = {
          file: undefined, fileName: undefined,
          alertModal: false, loadAlert: false, successReadAlert: false, successSaveAlert: false, errorAlert: false,
            showLists: false, registroList: [], existenList: [],
            actividades: [], tipos: [], categorias: [], instituciones: [],
          actSeleccionadas: [],
          totalPageA: 0,
          actualPage: 1,
          limite: 10,
          allselectA: true,
          iduser: 0,
          roles: [],          
          siblingCount: 1,
        }
        this.fileRef = React.createRef();

        // METODOS
        this.cleanComponent = this.cleanComponent.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.saveFile = this.saveFile.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.postData = this.postData.bind(this);
        this.page = this.page.bind(this);
        this.toggleChangeAll = this.toggleChangeAll.bind(this);
        this.onChangeLimite = this.onChangeLimite.bind(this);
    }

    componentDidMount() {
      let currentUser = this.context;
        this.populateInfoData();
        if (currentUser != null) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                //console.log('Ok');
            } else {
                this.isForbidden();
            }

        }
    }

    componentDidUpdate() {
        let currentUser = this.context;
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                //console.log('Ok');
            } else {
                this.isForbidden();
            }

        }
    }

    isForbidden() {
        this.props.history.push({
            pathname: homepage,
        })
    }

    page(num) {
        if (this.state.actualPage !== num) {
            this.setState({
                actualPage: num
            });
        }
    }

    pagePrevious() {
        if (this.state.actualPage !== 1) {
            let p = this.state.actualPage;
            this.setState({
                actualPage: p - 1
            });
        }
    }

    pageNext() {
        if (this.state.actualPage !== this.state.totalPageA) {
            let p = this.state.actualPage;
            this.setState({
                actualPage: p + 1
            });
        }
    }

    youAreMySibling(num) {
        let actualPage = this.state.actualPage;
        let sibling = this.state.siblingCount;
        let total = this.state.totalPageA;
        let valor = false;
        if (num === actualPage || num - sibling === actualPage || num + sibling === actualPage) {
            valor = true;
        }
        if (actualPage === 1 && (num - 1 === actualPage || num - 2 === actualPage || num - 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === 2 && (num - 1 === actualPage || num - 2 === actualPage)) {
            valor = true;
        }
        if (actualPage === total && (num + 1 === actualPage || num + 2 === actualPage || num + 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === total - 1 && (num + 1 === actualPage || num + 2 === actualPage)) {
            valor = true;
        }
        //console.log(num, valor);
        return valor;
    }

    reLoadTotalPage(lenActividades, limite) {
        this.setState({ totalPageA: Math.ceil(lenActividades / limite), actualPage: 1 });
        /*console.log('Total Paginas: ',this.state.totalPageA);*/
    }

    onChangeLimite(event) {
        //console.log('Cambio limite');
        //console.log(event.target.value);
        var num = event.target.value;
        this.setState({ limite: num, actualPage: 1});
        this.reLoadTotalPage(this.state.actividades.length, num);
    }

    handleChangeChk(act) {
        /*console.log(id);*/
        let idlist = this.state.actSeleccionadas;
        if (idlist.includes(act)) {
            let el = idlist.indexOf(act);
            if (el > -1) {
                idlist.splice(el, 1);
            }
        } else {
            idlist.push(act)
        }
        this.setState({ actSeleccionadas: idlist });

        if (this.state.actSeleccionadas.length === this.state.actividades.length) {
            this.setState({ allselectA: true });
        } else {
            this.setState({ allselectA: false });
        }
        //console.log(this.state.actSeleccionadas);
    }

    toggleChangeAll = e => {
        /*console.log(e.target.checked)*/
        if (e.target.checked) {
            let ids = [];
            this.state.actividades.map(act => { ids.push(act) });
            this.setState({ actSeleccionadas: ids, allselectA: e.target.checked });
        } else {
            this.setState({ actSeleccionadas: [], allselectA: e.target.checked });
        }
    }    

    saveFile(e) {
      if (e.target.files[0] !== undefined) {
        //console.log(this.state.fileName);
        //console.log(this.state.file);
        //console.log(e.target.files[0]);
        //console.log(e.target.files[0].name);
        this.setState({ file: e.target.files[0], fileName: e.target.files[0].name, showLists: false });

      }
    }

    cleanComponent() {
      this.fileRef.current.value = null;
      this.setState({
        file: undefined, fileName: undefined,
        alertModal: false, loadAlert: false, successReadAlert: false, successSaveAlert: false, errorAlert: false,
        showLists: false, registroList: [], existenList: []
      });
    }

    closeModal() {
      this.setState({ alertModal: false, successReadAlert: false, successSaveAlert: false, errorAlert: false });
    }

  uploadFile() {
      this.setState({ alertModal: true, loadAlert: true });
      //console.log(this.state.file);
      const formData = new FormData();
      formData.append("formFile", this.state.file);
      formData.append("fileName", this.state.fileName);
      try {
          fetch(localBack + "/api/FileUpload/TransformFile", { method: 'POST', body: formData })
          .then(response => response.json())
          .then(data => {
            //console.log(data);
            if (data.strEstado === "S") {
                this.setState({
                actividades: data.objDatos,
                loadAlert: false, successReadAlert: true, showLists: true,
                registroList: data.tlista, existenList: data.tlistaExisten,
                actualPage: 1,
                });
                let ids = [];
                this.state.actividades.map(act => { ids.push(act) });
                this.setState({ actSeleccionadas: ids });
                this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                this.populateInfoData();
            } else {
              this.setState({ loadAlert: false, errorAlert: true });
            }
          });

      } catch (ie) {
        this.setState({ loadAlert: false, errorAlert: true });
        //console.log("Error: " + ie);
      }
  }

  populateInfoData() {
    fetch(localBack + '/api/Insignia', {
      method: 'GET',
      /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
    })
      .then(response => response.json())
      .then(data => {
        //console.log(data);
        this.setState({
          categorias: data.objDatos, loadAlert: false,
        });
      });

    fetch(localBack + '/api/TipoActividad', {
      method: 'GET',
      /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
    })
      .then(response => response.json())
      .then(data => {
        //console.log(data);
        this.setState({
          tipos: data.objDatos, loadAlert: false,
        });
      });

      fetch(localBack + '/api/Entidad', {
          method: 'GET',
          /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
      })
          .then(response => response.json())
          .then(data => {
              //console.log(data);
              this.setState({
                  instituciones: data.objDatos,
                  loading: false
              });
          });

  }

  postData() {
    this.setState({
      alertModal: true, loadAlert: true, successReadAlert: false
    });
    const data = JSON.stringify(JSON.parse(JSON.stringify(this.state.actSeleccionadas).replace(/\\n/g, "\\n").replace(/\\r/g, "\\r").replace(/\\t/g, "\\t").replace(/\\b/g, "\\b").replace(/\\f/g, "\\f").replace(/\\'/g, "\\'").replace(/\\"/g, '\\"').replace(/\\&/g, "\\&")));

    fetch(localBack + '/api/RegistroActividad/PostRegistrosWithGestion', { method: 'POST', body: data })
      .then(response => response.json())
      .then(data => {
        if (data.strEstado == "S") {
          this.setState({
            actividades: data.objDatos,
            successSaveAlert: true,
            loadAlert: false, successReadAlert: false
          });
        }
        else {
          this.setState({ loadAlert: false, errorAlert: true });
          //console.log("Error: " + data.strMensaje);
        }  
      })
  }
  
    render() {
        const { actividades, tipos, categorias } = this.state;
      let pagesA = [];
      for (let i = 1; i <= this.state.totalPageA; i++) {
          pagesA.push(<></>);
      }
      return (
        <>
              <Modal isOpen={this.state.alertModal} centered>
                  <ModalHeader>
                      Procesando 
                  </ModalHeader>
              <ModalBody>
                <Alert isOpen={this.state.loadAlert} color="light"><div className="spinner-border text-secondary" role="status"><span className="visually-hidden"></span></div>&nbsp;Cargando</Alert>
                      <Alert isOpen={this.state.successReadAlert}>Archivo le&iacute;do con &eacute;xito.</Alert>
                      <Alert isOpen={this.state.successSaveAlert}>Se han guardado {this.state.actividades.length} datos con &eacute;xito.</Alert>
                <Alert isOpen={this.state.errorAlert} color="danger">Se ha producido un error al momento de guardar la informaci&oacute;n.</Alert>
              </ModalBody>
              <ModalFooter>
                   <div className="form-group row" id="cerrarForm" style={{ float: "right" }}>
                       <button type="button" className="btn btn-info button-space" disabled={this.state.loadAlert} onClick={this.closeModal}>Cerrar</button>
                   </div>
              </ModalFooter>
            </Modal>
            <div>
                <h1>Carga Masiva</h1>
                  <br />
                  <Card className="py-2">
                      <p className="card-text text-left">Bienvenido al m&oacute;dulo de carga masiva, para iniciar con la carga solo necesita de un documento Excel(.xls,.xlsx) con la informaci&oacute;n de las actividades.</p>
                      <p className="card-text text-left">En el siguiente enlace encontrara un formato a seguir para cargar la informaci&oacute;n.</p>
                      <a className="card-text text-left" href={plantilla} download="Plantilla">
                          Descargar Archivo
                      </a>
                      <br />
                      {/*<p className="card-text text-left">La cabeceras del formato de carga masiva son la siguientes:</p>*/}
                      {/*<Alert color="primary">*/}
                      {/*    <Table bordered>*/}
                      {/*        <thead>*/}
                      {/*            <tr>*/}
                      {/*                <th>CORREO</th>*/}
                      {/*                <th>APELLIDOS</th>*/}
                      {/*                <th>NOMBRES</th>*/}
                      {/*                <th>NOMBRE ACTIVIDAD</th>*/}
                      {/*                <th>CATEGOR&Iacute;A</th>*/}
                      {/*                <th>TIPO</th>*/}
                      {/*                <th>A&Ntilde;O</th>*/}
                      {/*                <th>HORAS</th>*/}
                      {/*                <th>DESCRIPCI&Oacute;N</th>*/}
                      {/*                <th>RESPONSABLE DE INFORMACI&Oacute;N</th>*/}
                      {/*            </tr>*/}
                      {/*        </thead>*/}
                      {/*        <tbody>*/}
                      {/*            <tr>                                      */}
                      {/*                <td>Correo instittucional</td>*/}
                      {/*                <td>Apellidos Estudiante</td>*/}
                      {/*                <td>Nombres Estudiante</td>*/}
                      {/*                <td>Nombre de la Actividad/ Proyecto/ Reto/ Curso</td>*/}
                      {/*                <td>Nombre Competencia</td>*/}
                      {/*                <td>Tipo actividad</td>*/}
                      {/*                <td>A&ntilde;o de la actividad</td>*/}
                      {/*                <td>Horas ocupadas, en caso de no ser necesarias colocar valor 0</td>*/}
                      {/*                <td>Descripcion de la actividad</td>*/}
                      {/*                <td>Siglas de la Institucion responsable de la informaci&oacute;n, maximo 30 caracteres.</td>*/}
                      {/*            </tr>                                  */}
                      {/*        </tbody>*/}
                      {/*    </Table>*/}
                      {/*</Alert>*/}
                      <p className="card-text text-left"> Recuerde revisar correctamente los nombres de las <strong>competencias</strong> y <strong>tipos de actividad</strong>, en caso de ser incorrectas la celda parecera en blanco.</p>
                  </Card>                  
                <form>
                  <input type="file" id="file-input" accept=".xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    onChange={this.saveFile} ref={this.fileRef} />
                  <Button className="btn-info btn-round" onClick={this.uploadFile} disabled={this.state.file === undefined || this.state.showLists}>Enviar</Button>
                  </form>                  
            </div>
            <div>
            { actividades && actividades.length > 0 ?
                <>
                          <div className="mb-5 py-2">
                              <Row hidden={this.state.actividades.length === 0} id={'newPagination'}>                                  
                                  <Col xs="2">
                                      <Input className="col-md-6" style={{ width: '5vw' }} type="select" onChange={this.onChangeLimite} value={this.state.limite} >
                                          <option hidden key={"sel-1"} selected={1 == this.state.limite} value={1}>{1}</option>
                                          <option key={"sel-5"} selected={5 == this.state.limite} value={5}>{5}</option>
                                          <option key={"sel-10"} selected={10 == this.state.limite} value={10}>{10}</option>
                                          <option key={"sel-25"} selected={25 == this.state.limite} value={25}>{25}</option>
                                          <option key={"sel-50"} selected={50 == this.state.limite} value={50}>{50}</option>
                                          <option key={"sel-100"} selected={100 == this.state.limite} value={100}>{100}</option>
                                      </Input>
                                  </Col>
                                  <Col>
                                      <Pagination hidden={pagesA.length < 1} >
                                          <PaginationItem active={this.state.actualPage === 1} onClick={() => { this.page(1); }}>
                                              <PaginationLink>
                                                  {1}
                                              </PaginationLink>
                                          </PaginationItem>
                                          <PaginationItem hidden={this.state.totalPageA < 5 || this.state.actualPage === 1} onClick={() => { this.pagePrevious(); }}>
                                              <PaginationLink previous />
                                          </PaginationItem>
                                          {pagesA.map((page, i) =>
                                          (
                                              <PaginationItem hidden={i + 1 === 1 || i + 1 === this.state.totalPageA || !this.youAreMySibling(i + 1)} active={this.state.actualPage === i + 1} onClick={() => { this.page(i + 1); }}>
                                                  <PaginationLink>
                                                      {i + 1}
                                                  </PaginationLink>
                                              </PaginationItem>)
                                          )}
                                          <PaginationItem hidden={this.state.totalPageA < 5 || this.state.actualPage === this.state.totalPageA} onClick={() => { this.pageNext(); }}>
                                              <PaginationLink next />
                                          </PaginationItem>
                                          <PaginationItem hidden={this.state.totalPageA === 1} active={this.state.actualPage === this.state.totalPageA} onClick={() => { this.page(this.state.totalPageA); }}>
                                              <PaginationLink>
                                                  {this.state.totalPageA}
                                              </PaginationLink>
                                          </PaginationItem>
                                      </Pagination>
                                  </Col>

                              </Row>
                              <div className="row d-flex flex-row">
                                 
                                  
                      <Table striped>
                        <thead>
                        <tr>
                            <th className={"w-1"}>#</th>
                            <th className={"w-1"}>Matricula</th>
                            <th className={"w-1"}>Estudiante</th>
                            <th className={"w-1"}>Correo</th>
                            <th className={"w-1"}>Actividad</th>
                            <th className={"w-1"}>Tipo</th>
                            <th className={"w-1"}>A&ntilde;o</th>
                            <th className={"w-1"}>Horas</th>
                            <th className={"w-1"}>Responsable Informaci&oacute;n</th>
                            <th className={"w-1"}>Responsable</th>
                            <th className={"w-1"}>Instituci&oacute;n</th>
                            <th className={"w-1"}>
                              <div><Input type="checkbox" checked={this.state.allselectA} onClick={this.toggleChangeAll} /> Todos</div>
                            </th>
                            {/*<th>Evidencia</th>*/}
                          </tr>
                        </thead>
                        <tbody>
                        {actividades.map((act, i) => {
                          const tipo = act.idaextipoactividad > 0 ? tipos.find(t => t.idaextipoactividad == act.idaextipoactividad) : "";
                          const responsable = act.registroActividadGestion && act.registroActividadGestion.responsable ? act.registroActividadGestion.responsable.apellidos + " " + act.registroActividadGestion.responsable.nombres : "";
                          return (<tr id={i} key={i} hidden={!(this.state.actualPage === Math.ceil((i + 1) / this.state.limite))}>
                            <td>{i+1}</td>
                            <td>{act.estudiante ? act.estudiante.codestudiante : "Estudiante no encontrado"}</td>
                            <td>{act.estudiante ? act.estudiante.apellidos + " " + act.estudiante.nombres : "Estudiante no encontrado"}</td>
                            <td>{act.estudiante ? act.estudiante.email : "Estudiante no encontrado"}</td>
                            <td>{act.nombre}</td>
                            <td>
                              <label>{tipo.nombre}</label>
                            </td>
                            <td>{act.anio}</td>
                              <td>{act.horas}</td>
                            <td>{this.state.instituciones.filter(inst => inst.idaexentidad === act.instacredita).map(actcat => actcat.nombre)}</td>
                              <td>{responsable}</td>
                            <td>{this.state.instituciones.filter(inst => inst.idaexentidad === act.idinstitucion).map(actcat => actcat.nombre)}</td>
                            <td>
                              <Input type="checkbox" id={'RA-' + i} checked={this.state.actSeleccionadas.includes(act) ? true : false} onChange={() => this.handleChangeChk(act)} />
                            </td>
                            {/*<td>{act.evidencia}</td>*/}
                          </tr>);
                          })}
                          {actividades.length == 0 ? <tr><p className=''>Actualmente no registra Actividades</p></tr> : null}
                        </tbody>
                      </Table>
                      <div>
                          <Button className="btn-info btn-round" onClick={this.postData} disabled={actividades.length == 0}>Guardar</Button>
                      </div>
                    </div>
                  </div>
                </>
                      :

                      <>
                          <br /><br />
                          <br /><br />
                          <br /><br />
                      </>
                  }
            </div>
          </>
        );
    }
}
FileUpload.contextType = AppContext;
